import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/protocol",
    name: "Protocol",
    component: () => import("../views/protocol"),
    meta: {
      title: "协议",
    },
  },

  {
    path: "/404",
    name: "NoPage",
    component: () => import("../views/404"),
    meta: {
      title: "404",
    },
  },
  {
    path: "/stagingAssessment",
    name: "stagingAssessment",
    component: () => import("../views/stagingAssessment"),
    meta: {
      title: "",
    },
  },

  {
    path: "/matchingResults",
    name: "matchingResults",
    component: () => import("../views/model8/matchingResults"),
    meta: {
      title: "匹配结果",
    },
  },

  {
    path: "/matchingResults_cpa",
    name: "matchingResults_cpa",
    component: () => import("../views/model8/matchingResults_cpa"),
    meta: {
      title: "匹配结果",
    },
  },
  {
    path: "/matchingResults_nwd",
    name: "matchingResults_nwd",
    component: () => import("../views/model8/matchingResults_nwd"),
    meta: {
      title: "匹配结果",
    },
  },

  {
    path: "/userOrg",
    name: "userOrg",
    component: () => import("../views/blue/userOrg"),
    meta: {
      title: "匹配结果",
    },
  },
  {
    path: "/registerEntryModel8",
    name: "registerEntryModel8",
    component: () => import("../views/deprecated/registerEntryModel8.vue"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  {
    path: "/userForm",
    name: "userForm",
    component: () => import("../views/newTemplate/userForm"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  {
    path: "/registerEntryModelks",
    name: "registerEntryModelks",
    component: () => import("../views/model8/registerEntryModelks"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  {
    path: "/registerEntryModelks_nwd",
    name: "registerEntryModelks_nwd",
    component: () => import("../views/model8/registerEntryModelks_nwd"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  {
    path: "/loanForm",
    name: "loanForm",
    component: () => import("../views/model8/loanForm.vue"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  },
  {
    path: "/applyResults",
    name: "applyResults",
    component: () => import("../views/model8/applyResults"),
    meta: {
      title: "",
    },
  },
  {
    path: "/stagingAssessmentModel8",
    name: "stagingAssessmentModel8",
    component: () => import("../views/deprecated/stagingAssessmentModel8.vue"),
    meta: {
      title: "放鑫钱包",
    },
  },
  {
    path: "/userFormBlue",
    name: "userFormBlue",
    component: () => import("../views/blue/userFormBlue"),
    meta: {
      title: "放鑫钱包",
    },
  },
  {
    path: "/stagingAssessmentModelHaier",
    name: "stagingAssessmentModelHaier",
    component: () => import("../views/model8/stagingAssessmentModelHaier"),
    meta: {
      title: "放鑫钱包",
    },
  },
  {
    path: "/capResults",
    name: "capResults",
    component: () => import("../views/model8/capResults"),
    meta: {
      title: "放鑫钱包",
    },
  },
  {
    path: "/stateWatingModel8",
    name: "stateWatingModel8",
    component: () => import("../views/model8/stateWatingModel8"),
    meta: {
      title: "产品推荐",
    },
  },
  {
    path: "/stateWatingModel8_nwd",
    name: "stateWatingModel8_nwd",
    component: () => import("../views/model8/stateWatingModel8_nwd"),
    meta: {
      title: "产品推荐",
    },
  },
  {
    path: "/userLoading",
    name: "userLoading",
    component: () => import("../views/newTemplate/userLoading"),
    meta: {
      title: "产品推荐",
    },
  },
  {
    path: "/userLoadingBlue",
    name: "userLoadingBlue",
    component: () => import("../views/blue/userLoadingBlue"),
    meta: {
      title: "产品推荐",
    },
  },
  {
    path: "/auditResult",
    name: "auditResult",
    component: () => import("../views/model8/auditResult"),
    meta: {
      title: "审核结果",
    },
  },
  {
    path: "/auditResult_nwd",
    name: "auditResult_nwd",
    component: () => import("../views/model8/auditResult_nwd"),
    meta: {
      title: "审核结果",
    },
  },
  {
    path: "/userAudit",
    name: "userAudit",
    component: () => import("../views/newTemplate/userAudit"),
    meta: {
      title: "审核结果",
    },
  },
  {
    path: "/userAudit1",
    name: "userAudit1",
    component: () => import("../views/newTemplate/userAudit1"),
    meta: {
      title: "审核结果",
    },
  },
  {
    path: "/userAuditBlue",
    name: "userAuditBlue",
    component: () => import("../views/blue/userAuditBlue"),
    meta: {
      title: "审核结果",
    },
  },

  {
    path: "/download",
    name: "download",
    component: () => import("../views/download"),
    meta: {
      title: "审核结果",
    },
  },

  {
    path: "/wxjq",
    name: "wxjq",
    component: () => import("../views/wxjq"),
    meta: {
      title: "微信借钱",
    },
  },
  {
    path: "/apiApplyResults",
    name: "apiApplyResults",
    component: () => import("../views/model8/apiApplyResults"),
    meta: {
      title: "申请结果",
    },
  },
  {
    path: "/userApplyResultsBlue",
    name: "userApplyResultsBlue",
    component: () => import("../views/blue/userApplyResultsBlue"),
    meta: {
      title: "申请结果",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
